import { render } from "./HouseHeader.vue?vue&type=template&id=c56e59b2"
import script from "./HouseHeader.vue?vue&type=script&lang=js"
export * from "./HouseHeader.vue?vue&type=script&lang=js"

import exportComponent from "/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__